import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPortalOpen, setIsPortalOpen] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const portalRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (portalRef.current && !portalRef.current.contains(e.target)) {
        setIsPortalOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMobileOpen]);

  const closeMobile = () => setIsMobileOpen(false);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <a href="#home">
            <span className="logo-icon">{'🎓'}</span>
            <span className="logo-text">MTC</span>
            <span className="logo-subtitle">School</span>
          </a>
        </div>

        <div className="nav-links">
          <a href="#home" className="nav-link">Home</a>
          <a href="#about" className="nav-link">About</a>
          <a href="#programs" className="nav-link">Programs</a>
          <a href="#features" className="nav-link">Features</a>
          <a href="#testimonials" className="nav-link">Testimonials</a>
          <div className="portal-dropdown" ref={portalRef}>
            <button className="nav-link" onClick={() => setIsPortalOpen(!isPortalOpen)}>
              Portal <span className={`dropdown-arrow ${isPortalOpen ? 'open' : ''}`}>{'\u25BC'}</span>
            </button>
            <div className={`dropdown-menu ${isPortalOpen ? 'open' : ''}`}>
              <Link to="/login?role=admin" className="dropdown-item" onClick={() => setIsPortalOpen(false)}>
                <i className="fas fa-user-shield"></i> Admin Login
              </Link>
              <Link to="/login?role=faculty" className="dropdown-item" onClick={() => setIsPortalOpen(false)}>
                <i className="fas fa-chalkboard-teacher"></i> Faculty Login
              </Link>
              <Link to="/login?role=student" className="dropdown-item" onClick={() => setIsPortalOpen(false)}>
                <i className="fas fa-user-graduate"></i> Student Login
              </Link>
            </div>
          </div>
          <div className="nav-cta">
            <a href="#enroll" className="btn btn-gold">Enroll Now</a>
          </div>
        </div>

        <button
          className={`hamburger ${isMobileOpen ? 'active' : ''}`}
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="Toggle menu"
        >
          <span className="hamburger-box">
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </span>
        </button>
      </div>

      <div className={`mobile-nav ${isMobileOpen ? 'open' : ''}`}>
        <a href="#home" className="mobile-nav-link" onClick={closeMobile}>Home</a>
        <a href="#about" className="mobile-nav-link" onClick={closeMobile}>About</a>
        <a href="#programs" className="mobile-nav-link" onClick={closeMobile}>Programs</a>
        <a href="#features" className="mobile-nav-link" onClick={closeMobile}>Features</a>
        <a href="#testimonials" className="mobile-nav-link" onClick={closeMobile}>Testimonials</a>
        <div className="mobile-portal-links">
          <Link to="/login?role=admin" onClick={closeMobile}>
            <i className="fas fa-user-shield"></i> Admin Login
          </Link>
          <Link to="/login?role=faculty" onClick={closeMobile}>
            <i className="fas fa-chalkboard-teacher"></i> Faculty Login
          </Link>
          <Link to="/login?role=student" onClick={closeMobile}>
            <i className="fas fa-user-graduate"></i> Student Login
          </Link>
        </div>
        <div className="mobile-cta">
          <a href="#enroll" className="btn btn-gold" onClick={closeMobile}>Enroll Now</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
